<script setup lang="ts">
import { computed, ref } from 'vue'
import { CLASS_ROOT } from '../constants'
import { useI18n } from 'vue-i18n'

export interface IDSKHeaderLanguageSwitcherProps {
  languages: Record<
    string,
    {
      title: string
      locale: string
    }
  >
}

const { locale } = useI18n()

const currentLocale = computed(() => locale.value.substring(0, 2))

const props = withDefaults(defineProps<IDSKHeaderLanguageSwitcherProps>(), {})

// Flag whether the language switcher is opened.
const active = ref<boolean>(false)

const setLocale = (newLocale: string) => {
  // Set new locale
  locale.value = newLocale
  // and close the menu.
  active.value = false
  window.localStorage.setItem('locale', newLocale)
}
</script>

<template>
  <div
    :class="[
      `${CLASS_ROOT}__brand-language`,
      {
        [`${CLASS_ROOT}__brand-language--active`]: active,
      },
    ]"
  >
    <button
      :class="`${CLASS_ROOT}__brand-language-button`"
      :aria-label="active ? 'Skryť jazykové menu' : 'Rozbaliť jazykové menu'"
      :aria-expanded="active"
      data-test-id="button-jazykove-menu"
      @click="active = !active"
      @focusout="active = false"
    >
      {{ languages[currentLocale].title }}
      <span :class="`${CLASS_ROOT}__link-arrow`"></span>
    </button>
    <ul :class="`${CLASS_ROOT}__brand-language-list`">
      <li
        v-for="language in props.languages"
        :key="language.locale"
        :class="`${CLASS_ROOT}__brand-language-list-item`"
      >
        <IDSKLink
          :class="[
            `${CLASS_ROOT}__brand-language-list-item-link`,
            {
              [`${CLASS_ROOT}__brand-language-list-item-link--selected`]:
                language.locale === currentLocale,
            },
          ]"
          :title="language.title"
          href="#"
          @click="() => setLocale(language.locale)"
        >
          {{ language.title }}
        </IDSKLink>
      </li>
    </ul>
  </div>
</template>
